import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { AudioToTextService } from './audio-to-text/audio-to-text.service';
import { PostType } from './iframe-communication/botapi-manager.service';
import { KeyValAdminService } from './key-val-admin.service';
import { LoginService } from '@shared-angular/services/login.service';
import { PlayAudioService } from './playaudio.service';
import { BotidService } from '@shared-angular/services/ragai/botid.service';
import { ToastrService } from '@shared-angular/services/toastr.service';

@Injectable({
  providedIn: 'root'
})
export class AudioManagerService {
  constructor(
    private attService: AudioToTextService,
    private keyValService: KeyValAdminService,
    private playAudio: PlayAudioService,
    private botidService: BotidService,
    private loginService: LoginService,
    private toastr: ToastrService,
    private http: HttpClient
  ) { }

  public async say(text: string, voice: string | undefined) {
    await this.playAudio.playAudio(text, this.botidService.getBotId(), voice);
  }

  public setText(text: string) {
    window.audiobot_overrideText = text;
  }

  public isMicMuted(): boolean {
    return this.attService.isMuted;
  }

  public unmuteMic(): void {
    this.attService.setMuted(false);
  }

  public muteMic(): void {
    this.attService.setMuted(true);
  }

  public setInstruction(text: string) {
    //localStorage.setItem("AUDIO_INSTRUCTION", text);
    return this.keyValService.storeKeyValEntry("AUDIO_INSTRUCTION", text, "CONFIGURATION");
  }

  public async getInstruction() {
    const val = (await this.keyValService.getKeyValByType("CONFIGURATION")).find((a) => a.key == "AUDIO_INSTRUCTION")?.value;
    if (!val) {
      return "";
    }
    return val as string;
  }

  public stopSpeaking() {
    this.playAudio.stopAudio();
  }

  public async botSay(text: string, voice: string | undefined) {
    console.log("playing audio");
    const blobparts = await this.mp3BufferFromString(text, voice);
    document.getElementById('audioplayer')?.remove();
    const audio = document.createElement('audio');
    audio.id = 'audioplayer';
    audio.autoplay = true;
    const blob = new Blob([blobparts], { type: 'audio/mp3' });
    const blobUrl = URL.createObjectURL(blob);
    audio.src = blobUrl;
    audio.onended = () => {
      void window.RAGAI.BOTAPI.postMessage(PostType.botSayEnded, "");
      void window.RAGAI.EVENTS._trigger_RAGAI_EVENT("RAGAI.AUDIO.botSayEnded");
    };
    document.body.appendChild(audio);
    return text;
  }

  public async mp3BufferFromString(payload: string, voice: string | undefined) {
    const botId = this.botidService.getBotId();
    await window.RAGAI.BOTAPI.postMessage(PostType.botSayLoad, "");
    void window.RAGAI.EVENTS._trigger_RAGAI_EVENT("RAGAI.AUDIO.botSayLoad");
    voice = (await this.keyValService.getKeyValByType("CONFIGURATION")).find((a) => a.key == "AUDIO_VOICE")?.value as string || undefined;
    if (voice == undefined) {
      const res = await firstValueFrom(this.http.get<{ voice: string }>("/api/toolbox/audio/getvoice/" + botId));
      voice = res.voice;
      await this.keyValService.storeKeyValEntry("AUDIO_VOICE", voice, "CONFIGURATION");
    }
    const body = { input: payload, botId, userId: this.loginService.loggedInUser?._id, voice };
    const content = await firstValueFrom(this.http.post("/api/toolbox/audio/create", body, { responseType: 'arraybuffer' }));
    await window.RAGAI.BOTAPI.postMessage(PostType.botSayLoadComplete, content);
    void window.RAGAI.EVENTS._trigger_RAGAI_EVENT("RAGAI.AUDIO.botSayLoadComplete");
    return content;
  }

}
